import { jsx as _jsx } from "react/jsx-runtime";
import {} from 'react';
import { useTranslation } from 'react-i18next';
import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { useMergeRefs } from '@/js/libs/hooks/useMergeRefs';
import { memoGeneric } from '@/js/libs/memo';
import { InputRenderer, FormField, isErrorVisible } from '@/js/libs/ui/src/V2';
import { useController } from '../hooks';
export const TextField = memoGeneric(function TextField({ control, name, disabled, renderError, label, labelTooltip, required, iconStart, iconEnd, width, withTouched = false, onChange: onChangeProp, onBlur: onBlurProp, trimValue = false, fieldPlaceholder, ...restProps }) {
    const [t] = useTranslation(['backend', 'common']);
    const { field: { onChange, value: noneUndefinedValue = '', onBlur, ...field }, fieldState, } = useController({ control, name });
    const mergedRefs = useMergeRefs(field.ref, restProps.inputRef);
    const { isTouched, error } = fieldState;
    const handleChange = useCallbackRef((e) => {
        onChangeProp?.(e);
        if (!e.defaultPrevented) {
            onChange(trimValue ? e.target.value.trim() : e.target.value);
        }
    });
    const handleBlur = useCallbackRef((event) => {
        onBlurProp?.(event);
        onBlur();
    });
    return (_jsx(FormField, { fieldPlaceholder: fieldPlaceholder, disabled: disabled, error: error?.message, label: label, labelTooltip: labelTooltip, name: name, renderError: renderError, required: required, touched: isTouched, withTouched: withTouched, children: _jsx(InputRenderer, { disabled: disabled, error: isErrorVisible(error?.message, isTouched, withTouched), iconEnd: iconEnd, iconStart: iconStart, width: width, onChange: handleChange, placeholder: t('common:ENTER'), ...restProps, ...field, ref: mergedRefs, value: noneUndefinedValue, onBlur: handleBlur }) }));
});
